import { useSearchParams, Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const CY = '#90E0EF';

export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const code = params.get('code');
  return (
    <div className="min-h-[100svh] bg-[#050505] text-[#f0f0f0] relative overflow-hidden" data-testid="payment-cancel-page">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'linear-gradient(#90E0EF 1px, transparent 1px), linear-gradient(90deg, #90E0EF 1px, transparent 1px)', backgroundSize: '44px 44px' }} />
      <div className="relative z-10 max-w-md mx-auto px-6 py-20 text-center">
        <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-6" style={{ border: '1.5px solid #3a2020' }}>
          <XCircle className="w-7 h-7 text-[#e88ba0]" />
        </div>
        <h1 className="font-outfit font-semibold text-white tracking-tight" style={{ fontSize: '1.8rem' }}>Payment cancelled</h1>
        <p className="text-xs font-mono text-[#888] mt-4 leading-relaxed">No payment was taken. You can return to the payment page whenever you're ready.</p>
        <div className="mt-8 flex flex-col items-center gap-3">
          {code && (
            <Link to={`/p/${code}`} data-testid="cancel-retry-btn"
              className="inline-flex items-center gap-2 px-5 py-3 text-[11px] font-mono uppercase tracking-[0.2em]" style={{ background: CY, color: '#050505' }}>
              <ArrowLeft className="w-4 h-4" /> Back to Payment
            </Link>
          )}
          <Link to="/" className="text-[11px] font-mono text-[#666] hover:text-white transition-colors">← The Relative Gallery</Link>
        </div>
      </div>
    </div>
  );
}
